import { useEffect, useState } from "react";
import { ArrowUpRight, Truck } from "lucide-react";
import { fetchUrgency } from "@/lib/urgency";
import { API, VENDOR_LABELS, VENDOR_COLORS } from "@/lib/api";

export default function RetailerCTA({ product, size = "lg", testId = "affiliate-cta", source = "main" }) {
  const v = VENDOR_LABELS[product.vendor] || product.vendor;
  const c = VENDOR_COLORS[product.vendor] || { bg: "#FF3366", text: "#fff" };
  const lg = size === "lg";
  const [occasion, setOccasion] = useState("");

  useEffect(() => {
    if (lg) fetchUrgency().then((u) => setOccasion(u?.enabled ? u.name : ""));
  }, [lg]);

  return (
    <div>
      <a
        href={`${API}/go/${product.slug}?src=${source}`}
        target="_blank"
        rel="noopener noreferrer sponsored"
        data-testid={testId}
        style={{ backgroundColor: c.bg, color: c.text }}
        className={`group pcs-cta brut w-full inline-flex items-center justify-center gap-2 font-bold uppercase tracking-wide ${
          lg ? "px-6 py-4 text-base" : "px-3 py-2 text-[11px]"
        }`}
      >
        <span>{lg ? `Check price on ${v}` : `View on ${v}`}</span>
        <ArrowUpRight
          className={`${lg ? "w-5 h-5" : "w-3.5 h-3.5"} transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1`}
          strokeWidth={3}
        />
      </a>
      {lg && (
        <div className="mt-3 flex items-center justify-center gap-2 font-mono uppercase text-[10px] tracking-widest opacity-70" data-testid="affiliate-cta-delivery-note">
          <Truck className="w-3.5 h-3.5" strokeWidth={2.5} />
          Check delivery dates on {v}{occasion ? ` before ${occasion}` : ""}
        </div>
      )}
    </div>
  );
}
